var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({staticClass:"ma-3"},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('v-icon',{staticClass:"mr-3"},[_vm._v(_vm._s(_vm.icon))]),_vm._v(_vm._s(_vm.text))],1)}
var staticRenderFns = []

export { render, staticRenderFns }